import React from "react";
import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

export const StoryCard = ({ story }) => {
  return (
    <Link
      to={`/story/${story.story_id}`}
      data-testid={`story-card-${story.story_id}`}
      className="group relative overflow-hidden rounded-2xl bg-[#0F1117] border border-white/8 glow-hover block"
    >
      <div className="aspect-[3/4] relative overflow-hidden">
        {story.cover_url ? (
          <img
            src={story.cover_url}
            alt={story.title}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-amber-900/40 to-slate-900" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#07080A] via-[#07080A]/60 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] px-2 py-1 rounded bg-[#07080A]/80 border border-amber-500/30 text-amber-300">
            {story.genre}
          </span>
          {story.is_contest_entry && (
            <span className="contest-pill text-[9px]">Contest</span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="font-serif text-xl leading-tight font-semibold text-white mb-1 line-clamp-2">
            {story.title}
          </h3>
          <p className="text-xs text-slate-400 line-clamp-2">{story.tagline}</p>
          <div className="mt-3 flex items-center justify-between">
            <span className="text-[11px] text-slate-500">by {story.author_name}</span>
            <div className="flex items-center gap-1 text-[11px] text-amber-400/80">
              {story.is_featured ? <Sparkles className="h-3 w-3" /> : <Lock className="h-3 w-3" />}
              {story.is_featured ? "Free preview" : `${story.chapters_count} ch`}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
